import React, { useContext, useCallback } from "react";
import MaintenanceTaskContext from "module/maintenanceTask/context/MaintenanceTaskContext";
import { MaintenanceTaskInterface } from "module/maintenanceTask/types";
import t from "module/translations";
import XLabelField from "component/labelField/XLabelField";
import MaintenanceTaskFieldMetaDataContext from "module/maintenanceTask/validation/fieldMetaData/MaintenanceTaskFieldMetaDataContext";
import { getFieldMetaDataWithErrorHandling } from "module/fieldMetaData/getFieldMetaData";
import { MAINTENANCE_TASK_NAME_FIELD_NAME } from "module/maintenanceTask/constants";
import MaintenanceTaskChangeContext from "module/maintenanceTask/change/MaintenanceTaskChangeContext";
import TextField from "component/textField/TextField";

const MaintenanceTaskNameLabelFieldContainer: React.FC = () => {
  const { entity } = useContext(MaintenanceTaskContext);
  const { change: changeHelper } = useContext(MaintenanceTaskChangeContext);
  const { getFieldMetaData } = useContext(MaintenanceTaskFieldMetaDataContext);

  const maintenanceTask = entity as MaintenanceTaskInterface;

  const change = useCallback(
    (name?: string) => {
      changeHelper({ name });
    },
    [changeHelper]
  );

  const { warnings, errors, isEditable } = getFieldMetaDataWithErrorHandling(
    () => getFieldMetaData(MAINTENANCE_TASK_NAME_FIELD_NAME)
  );

  const label = t.maintenanceTask.nameText;

  return isEditable ? (
    <TextField
      {...{
        value: maintenanceTask.name,
        change,
        label,
        errors,
      }}
    />
  ) : (
    <XLabelField
      {...{ caption: label, label: maintenanceTask.name, errors, warnings }}
    />
  );
};

export default React.memo(MaintenanceTaskNameLabelFieldContainer);
